import React, { FC } from "react";

import { Attachment } from "@/data/attachments/types";
import { IWorkOrder } from "@/data/work-orders";
import { Flex } from "@/eworkitComponents/components";
import { WorkOrderAttachmentsSection } from "@/views/components/WorkOrder/WorkOrderAttachmentsSection";

import { WorkOrderCommercialSection } from "./WorkOrderCommertialContactSection";
import { WorkOrderContactSection } from "./WorkOrderContactSection";
import { WorkOrderInformation } from "./WorkOrderInformation";

export interface IWorkOrderDetailsSectionsProps {
  workOrder: IWorkOrder;
  externalAttachments: Attachment[];
}

export const WorkOrderDetailsSections: FC<IWorkOrderDetailsSectionsProps> = ({
  workOrder,
  externalAttachments,
  children,
}) => {
  const showAttachmentsSection = Boolean(externalAttachments?.length);

  return (
    <Flex width={12} direction="column" innerMargin="md">
      <WorkOrderInformation workOrder={workOrder} />

      {showAttachmentsSection && <WorkOrderAttachmentsSection attachments={externalAttachments} />}

      <WorkOrderContactSection origin={workOrder.origin} contactPerson={workOrder.contactPerson} />

      <WorkOrderCommercialSection
        supplier={{
          contactPersonEmail: workOrder.supplierContactPersonEmail,
          contactPersonPhone: workOrder.supplierContactPersonPhone,
          contactPersonName: workOrder.supplierContactPersonName,
          legalName: workOrder.supplierLegalName,
          vatNo: workOrder.supplierVatNo,
        }}
        otherSupplier={workOrder.otherSupplier}
      />

      {children}
    </Flex>
  );
};
